import $ from 'jquery';
import 'slick-carousel';

$('.page-header__images').each((i, elem) => {
    const $slider = $(elem);

    $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        arrows: false,
        dots: false,
        draggable: false,
        fade: true,
    });
});
